module.exports = __webpack_public_path__ + "static/media/lock-sol.96554af3.svg";